export default __webpack_public_path__ + "images/d7b743e000c1413c1356302a4d94480b-camp.webp";